/* ===========================================================
   MAB – Leasing / Finanzierung (B2B)
   Modal-Logik für das Anfrage-Formular.

   - Öffnen/Schließen per Event-Delegation (überlebt Varianten-
     Swaps, bei denen das Inline-Widget neu gerendert wird)
   - Modal wird beim ersten Öffnen nach document.body verschoben,
     damit position:fixed nicht von Sticky-/Transform-Containern
     beeinflusst wird
   - sync() überträgt Rate/Laufzeit/Preis der aktuellen Variante
     aus den data-Attributen des Widgets in Modal und Hidden-Felder
     (wird auch von template-product.js bei Variantenwechsel gerufen)
   =========================================================== */
(function () {
  'use strict';

  if (window.MABLeasing) return;

  var lastFocused = null;

  function ensureInBody(modal) {
    if (modal && modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }
    return modal;
  }

  function getModalFor(wrapper) {
    if (!wrapper) return null;
    return document.getElementById(wrapper.getAttribute('data-modal-id'));
  }

  function sync(wrapper) {
    wrapper = wrapper || document.querySelector('[data-product-leasing]');
    var modal = getModalFor(wrapper);
    if (!wrapper || !modal) return;

    if (wrapper.getAttribute('data-eligible') !== 'true') {
      close(modal);
      return;
    }

    var textTargets = {
      'data-rate': '[data-leasing-rate]',
      'data-term': '[data-leasing-term]',
      'data-years': '[data-leasing-years]',
      'data-total': '[data-leasing-total]',
      'data-product-title': '[data-leasing-product]',
      'data-sku': '[data-leasing-sku]'
    };
    Object.keys(textTargets).forEach(function (attr) {
      var value = wrapper.getAttribute(attr);
      if (value === null) return;
      modal.querySelectorAll(textTargets[attr]).forEach(function (el) {
        el.textContent = value;
      });
    });

    var skuLine = modal.querySelector('.mab-leasing-modal__sku');
    if (skuLine) {
      skuLine.classList.toggle('hidden', !wrapper.getAttribute('data-sku'));
    }

    var inputSources = {
      product: 'data-product-title',
      sku: 'data-sku',
      url: 'data-url',
      total: 'data-total',
      rate: 'data-rate',
      term: 'data-term'
    };
    Object.keys(inputSources).forEach(function (key) {
      var value = wrapper.getAttribute(inputSources[key]);
      if (value === null) return;
      modal.querySelectorAll('[data-leasing-input="' + key + '"]').forEach(function (input) {
        input.value = value;
      });
    });
  }

  function open(modal) {
    if (!modal || modal.classList.contains('is-open')) return;
    ensureInBody(modal);
    lastFocused = document.activeElement;
    modal.classList.add('is-open');
    document.documentElement.classList.add('mab-leasing-lock');
    var focusTarget = modal.querySelector('input:not([type="hidden"])') || modal.querySelector('[data-leasing-close]');
    if (focusTarget) focusTarget.focus();
  }

  function close(modal) {
    if (!modal || !modal.classList.contains('is-open')) return;
    modal.classList.remove('is-open');
    document.documentElement.classList.remove('mab-leasing-lock');
    if (lastFocused && document.contains(lastFocused)) lastFocused.focus();
    lastFocused = null;
  }

  document.addEventListener('click', function (event) {
    var openBtn = event.target.closest('[data-leasing-open]');
    if (openBtn) {
      event.preventDefault();
      var wrapper = openBtn.closest('[data-product-leasing]');
      var modal = getModalFor(wrapper);
      if (modal) {
        sync(wrapper);
        open(modal);
      }
      return;
    }

    var closeBtn = event.target.closest('[data-leasing-close]');
    if (closeBtn) {
      event.preventDefault();
      close(closeBtn.closest('.mab-leasing-modal'));
    }
  });

  document.addEventListener('keydown', function (event) {
    var openModal = document.querySelector('.mab-leasing-modal.is-open');
    if (!openModal) return;

    if (event.key === 'Escape') {
      close(openModal);
      return;
    }

    if (event.key === 'Tab') {
      var focusable = openModal.querySelectorAll(
        'button, [href], input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  });

  // Nach Formular-Submit (Erfolg oder Validierungsfehler) lädt die
  // Seite neu – das Modal mit der Meldung automatisch wieder öffnen.
  function autoOpen() {
    var flag = document.querySelector('.mab-leasing-modal [data-leasing-autoopen]');
    if (!flag) return;
    var modal = flag.closest('.mab-leasing-modal');
    sync(document.querySelector('[data-product-leasing]'));
    open(modal);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', autoOpen);
  } else {
    autoOpen();
  }

  window.MABLeasing = { sync: sync, open: open, close: close };
})();
